module.exports = __webpack_public_path__ + "static/media/YS_upto85equityrelease_Trans_EN.f232a98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_upto85equityrelease_Trans_EN.png
// module id = 418
// module chunks = 0